import React from 'react';
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import { useUIUtils } from 'hooks/useUIUtils';
import { BotonNuevo, nombreEstatus, nombreTipoCobro, siNo } from '../comun';

const List = ({ match }) => {
    const { path } = match;
    const { changeGlobalTitle } = useUIUtils();
    const columns = [
        { renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: 'editar' },
        {
            field: 'id', headerName: 'Id', maxWidth: 70, renderCell: (params) => (
                <a href={`${path}/edit/${params.row.id}`}>{params.value}</a>)
        },
        {
            field: 'nombre', headerName: 'Nombre', minWidth: 180, renderCell: (params) => (
                <a href={`${path}/edit/${params.row.id}`}>{params.value}</a>)
        },
        { field: 'tipo', headerName: 'Tipo', minWidth: 120, valueGetter: (value) => nombreTipoCobro(value) },
        { field: 'moneda', headerName: 'Moneda', minWidth: 90 },
        { field: 'clave_Fiscal', headerName: 'Clave fiscal', minWidth: 110 },
        { field: 'autorizacion_Necesaria', headerName: 'Autorizacion', minWidth: 120, valueGetter: (value) => siNo(value) },
        { field: 'dar_Cambio', headerName: 'Da cambio', minWidth: 110, valueGetter: (value) => siNo(value) },
        { field: 'estatus', headerName: 'Estatus', minWidth: 100, valueGetter: (value) => nombreEstatus(value) }
    ];

    React.useEffect(() => {
        changeGlobalTitle('Formas de cobro', 'Listado de formas de cobro del punto de venta.');
    }, [changeGlobalTitle]);

    return (
        <div className='container-fluid'>
            <div className='col-md-12'>
                <BotonNuevo to={`${path}/add`} />
            </div>
            <div className='col-md-12'>
                <ListTable
                    columns={columns}
                    path={path}
                    url='pv/PvFormasCobros/GetList?'
                />
            </div>
        </div>
    );
};

export { List };
